import * as React from 'react';
import { LayoutEnum } from '@app/common';
import { useRootStore } from '../../../../providers/root-store-provider';
import { HeaderHorizontalShared } from '../horizontal/shared/header-horizontal-shared';
import { HeaderVerticalShared } from '../vertical/shared/header-vertical-shared';
import { Responsive } from '../../../../components/app/responsive/responsive';
import { HeaderMobileShared } from '../mobile/shared/header-mobile-shared';
import { cn } from '../../../../utils/tailwind';

export const HeaderShared: React.FC = () => {
    const rootStore = useRootStore();
    const { layout, showHeaderBar } = rootStore.themeStore;
    const isSticky = layout === LayoutEnum.Vertical || showHeaderBar;

    return (
        <div
            className={cn('relative z-[901]', isSticky && 'sticky')}
            style={isSticky ? { top: showHeaderBar ? '4rem' : '0' } : undefined}
        >
            <Responsive breakpoint="vl" type="max">
                <HeaderMobileShared />
            </Responsive>
            <Responsive breakpoint="vl">
                <>
                    {layout === LayoutEnum.Horizontal && <HeaderHorizontalShared />}
                    {layout === LayoutEnum.Vertical && <HeaderVerticalShared />}
                </>
            </Responsive>
        </div>
    );
};
